import { RootState } from '../../store';

export const getRolesSelector = (state: RootState) => state?.roleReducer?.roles;
